import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "37",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.945 22.476c0-.937.682-1.704 1.515-1.704h10.604v-9.09h-8.08c-1.115 0-2.02-1.017-2.02-2.271V.32H3.857C2.183.321.826 1.847.826 3.73v29.54c0 1.881 1.357 3.408 3.03 3.408h18.178c1.674 0 3.03-1.526 3.03-3.408v-9.09H14.46c-.833 0-1.515-.76-1.515-1.704M16.985.321v9.09h8.08zm19.7 20.948-5.05-5.68c-.592-.666-1.55-.666-2.143 0-.591.665-.591 1.743 0 2.41l2.521 2.773h-6.949v3.409h6.95l-2.464 2.771a1.78 1.78 0 0 0-.446 1.205c0 .44.148.872.444 1.205.591.666 1.55.666 2.142 0l5.05-5.68a1.806 1.806 0 0 0-.056-2.413"
    }, null, -1)
  ])))
}
export default { render: render }